package ai.flowstorm.studio.ui.design.dialogue.graph

import ai.flowstorm.common.ui.Icon
import ai.flowstorm.studio.model.Graph
import ai.flowstorm.studio.ui.design.dialogue.GraphEditor
import ai.flowstorm.studio.ui.form.StyleSelect
import io.kvision.form.check.CheckBox
import io.kvision.form.select.Select
import io.kvision.i18n.I18n

class SetStyleEditor(graphEditor: GraphEditor): NodeEditor<Graph.SetStyle>(graphEditor){
    override val form = object : NodeForm(Graph.SetStyle.serializer()) {
        init {
            add(Graph.SetStyle::style, StyleSelect())
            add(Graph.SetStyle::isListening, CheckBox(label = I18n.tr("Listening")))
            add(Graph.SetStyle::scope, Select(
                    options = listOf("none" to "None", "one" to "One", "all" to "All"),
                    label = I18n.tr("Scope"),
                    value = "None"
                )
            )
        }
    }
    override val tabPanel = object : NodeTabPanel() {
        init {
            addTab(I18n.tr("Properties"), form, Icon.Properties.def)
            activeIndex = 1
        }
    }

    override fun load(node: Graph.SetStyle) {
        super.load(node)
        form.load(node)
    }
}